export class ProfileMin {
  public constructor() {
    this.ProfileId = 0;
    this.OrgInd = false;
    this.Member = false;
    this.Prospect = false;
    this.Email = '';
    this.ReportName = '';
    this.OrgName = '';
    this.FirstName = '';
    this.LastName = '';
    this.Title = '';
    this.WorkPhone = '';
    this.HomePhone = '';
    this.CellPhone = '';
    this.PhoneDefault = '';
    this.Address1 = '';
    this.Address2 = '';
    this.City = '';
    this.State = '';
    this.Zip = '';
    this.MainRelatedProfileName = '';
    this.MainRelatedProfileId = 0;
    this.ProfileTypeId = 0;
    this.Selected = false;
  }

  public ProfileId: number;
  public OrgInd: boolean;
  public Member: boolean;
  public Prospect: boolean;
  public Email: string;
  public ReportName: string;
  public OrgName: string;
  public Prefix: string;
  public FirstName: string;
  public LastName: string;
  public Title: string;
  public WorkPhone: string;
  public HomePhone: string;
  public CellPhone: string;
  public PhoneDefault: string;
  public Address1: string;
  public Address2: string;
  public City: string;
  public State: string;
  public Zip: string;
  public MainRelatedProfileName: string;
  public MainRelatedProfileId: number;
  public ProfileTypeId: number;
  public Website: string = '';
  public Selected: boolean;
  public MemberTypeIconColor: string = '';
}
